import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { ILieferantEinstellungenState } from './state';

export const GET_BENUTZER_DATA = 'GetBenutzerData';
export const GET_BENUTZER_LOADING = 'GetBenutzerLoading';
export const GET_BENUTZER_TOTAL_NUMBER_OF_RECORDS = 'getBenutzerTotalNumberOfRecords';
export const GETBENUTZERDETAILS = 'getBenutzerDetails';

export const GETLIEFERANTBENUTZERDATA = 'getLieferantBenutzerData';

export const getters: GetterTree<ILieferantEinstellungenState, IRootState> = {
    [GET_BENUTZER_DATA]: (state) => state.benutzerInfoSearchResultApiDto,
    [GET_BENUTZER_LOADING]: (state) => state.benutzerLoading,
    [GET_BENUTZER_TOTAL_NUMBER_OF_RECORDS]: (state) => state.benutzerTotalNumberOfRecords,
    [GETBENUTZERDETAILS]: (state) => state.benutzerDetails,
    [GETLIEFERANTBENUTZERDATA]: (state) => state.lieferantBenutzerData
};
